const GA_MEASUREMENT_ID = process.env.REACT_APP_GA4_MEASUREMENT_ID || 'G-CCTHBY8XY3';
const GA_SCRIPT_ID = 'scrolled-ga4-script';

const expireCookie = (name, domain = '') => {
  const domainAttribute = domain ? `; Domain=${domain}` : '';
  document.cookie = `${name}=; Max-Age=0; Path=/${domainAttribute}; SameSite=Lax`;
};

const clearAnalyticsStorage = () => {
  const cookieNames = document.cookie
    .split(';')
    .map(cookie => cookie.split('=')[0].trim())
    .filter(name => name === '_ga' || name.startsWith('_ga_') || name.startsWith('ph_'));

  const hostname = window.location.hostname;
  const parentDomain = hostname.split('.').length > 1
    ? `.${hostname.split('.').slice(-2).join('.')}`
    : '';

  cookieNames.forEach(name => {
    expireCookie(name);
    if (hostname) expireCookie(name, hostname);
    if (parentDomain) expireCookie(name, parentDomain);
  });

  Object.keys(localStorage)
    .filter(key => key.startsWith('ph_') || key.toLowerCase().includes('posthog'))
    .forEach(key => localStorage.removeItem(key));
};

export const disableAnalytics = () => {
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = true;

  if (typeof window.gtag === 'function') {
    window.gtag('consent', 'update', { analytics_storage: 'denied' });
  }

  clearAnalyticsStorage();
};

export const enableAnalytics = () => {
  window[`ga-disable-${GA_MEASUREMENT_ID}`] = false;
  window.dataLayer = window.dataLayer || [];
  window.gtag = window.gtag || function gtag() {
    window.dataLayer.push(arguments);
  };

  window.gtag('consent', 'update', { analytics_storage: 'granted' });

  if (!document.getElementById(GA_SCRIPT_ID)) {
    const script = document.createElement('script');
    script.id = GA_SCRIPT_ID;
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(GA_MEASUREMENT_ID)}`;
    document.head.appendChild(script);
  }

  if (!window.__scrolledGaConfigured) {
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID, { anonymize_ip: true });
    window.__scrolledGaConfigured = true;
  }
};

export { GA_MEASUREMENT_ID };
